import { render, staticRenderFns } from "./Ordenservicio.vue?vue&type=template&id=b5eb2fbe"
import script from "./Ordenservicio.vue?vue&type=script&lang=js"
export * from "./Ordenservicio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports